import { useContext } from 'react'
import { AxiosSetUpContext } from '@/contexts'

export const useAxios = () => useContext(AxiosSetUpContext)
